export default "__VITE_ASSET__29c7188e__"